import { withTheme } from '@emotion/react';
import styled from '@emotion/styled';
import {
  compose,
  layout,
  LayoutProps,
  BorderProps,
  border,
  space,
  SpaceProps,
  variant
} from '@lucid/theme';
import { Accordion as ReactAccordion } from 'react-accessible-accordion';

import AccordionButton from './accordion-button';
import AccordionHeading from './accordion-heading';
import AccordionItem from './accordion-item';
import AccordionPanel from './accordion-panel';

export type AccordionComponentTypes = 'button'
  | 'heading'
  | 'item'
  | 'panel';

export interface AccordionProps
  extends BorderProps,
    LayoutProps,
    SpaceProps {
      /** Don't autocollapse items when expanding other items. */
      allowMultipleExpanded?: boolean;
      /** Allow the only remaining expanded item to be collapsed. */
      allowZeroExpanded?: boolean;
      /** Class(es) to apply to element. */
      className?: string;
      /** Accepts an array of strings and any `AccordionItem`
       * whose uuid prop matches any one of these strings will be expanded on mount.
       */
      preExpanded?: string[];
      // title?: string;
      /** Callback which is invoked when items are expanded or collapsed.
       * Gets passed uuids of the currently expanded `AccordionItem`s.
       */
      onChange?: (value: string[]) => void;
}

const accordionStyleProps = compose(border, layout, space);

const AccordionBase = styled(ReactAccordion)<AccordionProps>(
  {
    label: 'accordion',
    flex: '0 1 100%',
    maxWidth: '100%'
  },
  variant({
    scale: 'accordion',
    variants: {
      defaultVariant: {}
    }
  }),
  accordionStyleProps
);

const Accordion = Object.assign(
  withTheme(AccordionBase),
  {
    Panel: AccordionPanel,
    Item: AccordionItem,
    Heading: AccordionHeading,
    Button: AccordionButton
  }
);

export { Accordion };

export default Accordion;
